import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const checkbox: SxStyle = {
  padding: 0,

  ' & > svg': {
    fill: (p) => p.palette.primary[500],
  },
};
